module.exports = __webpack_public_path__ + "img/28.5d9a9b88.webp";